import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

export type StatusData = {
  id: string;
  status: string;
  isOccupied: boolean;
  tauxOccupation: number;
  hasStacks: boolean;
  hasInventory: boolean;
  hasPallet: boolean;
  hasCage: boolean;
  isOperationInProgress: boolean;
  reservationType: string;
  operationType: string;
  aConfirmer: boolean;
  verifierLe: string;
  verifierParUsager: string;
  uniteDTPlusVieux: Date;
  uniteDTPlusJeune: Date;
};

export interface StatusResource {
  statusPlan: StatusData[];
}

const initialState = {
  statusPlan: [],
} satisfies StatusResource as StatusResource;

export const statusSlice = createSlice({
  name: "statusSlice",
  initialState,
  reducers: {
    setStatusPlan(state, action: PayloadAction<StatusData[]>) {
      state.statusPlan = action.payload;
    },
    resetStatusPlan: state => {
      state.statusPlan = initialState.statusPlan;
    },
    updateGridElement: (state, action: PayloadAction<StatusData>) => {
      const changedElementIndex = state.statusPlan.findIndex(
        e => e.id == action.payload.id
      );
      if (changedElementIndex >= 0) {
        setNewElementStatusFromPayload();
      } else {
        state.statusPlan.push(action.payload);
      }

      function setNewElementStatusFromPayload() {
        state.statusPlan[changedElementIndex].id = action.payload.id;
        state.statusPlan[changedElementIndex].status = action.payload.status;
        state.statusPlan[changedElementIndex].isOccupied =
          action.payload.isOccupied;
        state.statusPlan[changedElementIndex].hasInventory =
          action.payload.hasInventory;
        state.statusPlan[changedElementIndex].hasCage = action.payload.hasCage;
        state.statusPlan[changedElementIndex].hasPallet =
          action.payload.hasPallet;
        state.statusPlan[changedElementIndex].hasStacks =
          action.payload.hasStacks;
        state.statusPlan[changedElementIndex].isOperationInProgress =
          action.payload.isOperationInProgress;
        state.statusPlan[changedElementIndex].reservationType =
          action.payload.reservationType;
        state.statusPlan[changedElementIndex].operationType =
          action.payload.operationType;
        state.statusPlan[changedElementIndex].aConfirmer = action.payload.aConfirmer;
        state.statusPlan[changedElementIndex].verifierLe = action.payload.verifierLe;
        state.statusPlan[changedElementIndex].verifierParUsager = action.payload.verifierParUsager;
        state.statusPlan[changedElementIndex].uniteDTPlusVieux = action.payload.uniteDTPlusVieux;
        state.statusPlan[changedElementIndex].uniteDTPlusJeune = action.payload.uniteDTPlusJeune;
        state.statusPlan[changedElementIndex].tauxOccupation = action.payload.tauxOccupation;
      }
    },
  },
});

export const { setStatusPlan, resetStatusPlan, updateGridElement } =
  statusSlice.actions;
export default statusSlice.reducer;
